// extracted by mini-css-extract-plugin
export default {"pieWrapper":"BasePieChart_pieWrapper__slVTb"};